import { Link } from 'react-router-dom'
import { Pass } from 'data/Pass'
import React from 'react'
import { getFormattedShowStartTime } from 'utils/show'
import moment from 'moment'
import { useStyles } from './styles'
import { isPopulated } from 'utils/populated'

interface PassItemProps {
    pass: Pass
}

export const PassItem: React.FC<PassItemProps> = ({ pass }) => {
    const classes = useStyles()

    return isPopulated(pass.show) ? (
        <Link className={classes.pass} to={pass.show.path}>
            <div className={classes.header}>
                <span className={classes.title}>{pass.show.title}</span>

                <span className={classes.dateAndCode}>{`Showtime: ${getFormattedShowStartTime(
                    pass.show.startTime,
                )}`}</span>
            </div>
            <div className={classes.bottom}>
                <span className={classes.dateAndCode}>{`Purchased ${moment(pass.createdAt).format('MM-DD-YY')}`}</span>
                <span className={classes.dateAndCode}>Conf. code: {pass.redemptionCode.toUpperCase()}</span>
            </div>
        </Link>
    ) : null
}

export default React.memo(PassItem)
